module.exports = __webpack_public_path__ + "img/effects-19.2b53ce55.png";